import {DictionaryItem} from './dictionary.model';
import {GenericEntity} from './generic-entity.model';
import {CpiSalesConfiguration} from './offer.model';
import {PartnerIdentity} from './partner.model';
import {PgSalesConfiguration} from './sales-pg.model';
import {SystemFile} from './system-file.model';
import {Document} from './document.model';


export class ProductBase {
    code: string;
    nameShort: string;
    nameFull: string;

    constructor(props = {}) {
        Object.assign(this, props);
    }
}

export enum ProductStatus {
    ACTIVE = 'ACTIVE',
    CANCEL = 'CANCEL',
    CLOSE = 'CLOSE',
    DRAFT = 'DRAFT',
}

export enum ProductConfigurationType {
    CPI = 'CPI',
    PG = 'PG',
}

export enum ProductDocumentType {
    CPI = 'PRODUCT_CPI',
    PG = 'PRODUCT_UPG',
}


export class Product extends GenericEntity {
    code: string;
    configuration?: ProductConfiguration;
    documentType?: ProductDocumentType;
    nameFull: string;
    nameShort: string;
    owu: string;
    partners: (string | { code: string, name: string })[];
    salesStartDate: string;
    salesEndDate: string;
    status: DictionaryItem;
    statusDate: string;
    productPrintout: ProductPrintout;
    productPrintoutAttachments: ProductPrintoutAttachment[];

    constructor(props = {}) {
        super(props);
        Object.assign(this, props);
    }
}

export class ProductPrintout {
    isOwu: boolean;
    isKid: boolean;
    policyTemplate: object;
    remoteApprovalPolicyTemplate: object;
    remotePolicyTemplate: object;
    printoutOrder: DictionaryItem = new DictionaryItem({code: 'POL_KID'});
}

export class ProductPrintoutAttachment {
    attachmentFile: Document;
    attachmentCount: number;
}

export class ProductConfiguration {
    productType: ProductConfigurationType;
    configurationFile: SystemFile;
    configurationNote: string;
    kidFile: Document;
    owuFile: Document;
}

export class ProductIdentity {
    id: number;
    code: string;
    nameShort: string;
    nameFull: string;
    owu: string;
    productType: ProductConfigurationType;
}

export class ProductVariantIdentity {
    id: number;
    code: string;
    name: string;
    description: string;
}

export enum ProductConfigurationStatus {
    DRAFT = 'DRAFT',
    COMPLETED = 'COMPLETED',
}

export class InsuredSubject {
    assortmentGroup: DictionaryItem;
    assortmentSubgroup: DictionaryItem;
    assortmentIndex: string;
    brand: string;
    model: string;
    serial: string;
    description: string;
    sumInsured: number;
    warranty: DictionaryItem;
    warrantyFromVariant: number;
}

export class GenericProductConfiguration {
    insuranceStartDate: string;
    insuranceEndDate: string;
    insuredSubject: InsuredSubject;
    purchaseType: DictionaryItem;
    promotion: string | boolean;
    sellDate: string;
    outlet: boolean;
    leasing: boolean;
}

export class InsuredProduct {
    configuration: GenericProductConfiguration;
    configurationStatus: ProductConfigurationStatus;
}

export class InsuredProductCpi extends InsuredProduct {
    configuration: CpiSalesConfiguration;
}

export class InsuredProductPg extends InsuredProduct {
    configuration: PgSalesConfiguration;
}

export class Clause {
    item: DictionaryItem;
    selected: boolean;
    description: string;

    constructor(props = {}) {
        Object.assign(this, props);
    }
}

export class CreditDefinition {
    contractNumber: string;
    creditContractDurationInMonths: number;
    creditValue: number;
    firstCreditInstallmentDate: string;
    installmentCount: number;
    installmentValue: number;
    monthExtensionCount: number;
}

export class BeneficiaryInformation {
    description: string;
}

export class ProductListItem {
    id: number;
    code: string;
    nameFull: string;
    nameShort: string;
    owu: string;
    salesStartDate: string;
    salesEndDate: string;
    status: DictionaryItem;
    partners: PartnerIdentity[];
    configurationType: ProductConfigurationType;
    acquisition: boolean;

    constructor(props = {}) {
        Object.assign(this, props);
    }
}

export class ActiveProducts {
    pg: boolean;
    cpi: boolean;
}
